
export function compareNumericString(rowA, rowB, id, desc) {

    let a = parseFloat(rowA.values[id]);
    let b = parseFloat(rowB.values[id]);
    if (a > b) return 1; 
    if (a < b) return -1;
    return 0;
}

export function compareString(rowA, rowB, id, desc) {
    // Extract the course code values
    console.log(rowA);
    console.log(rowB);
    let a;
    let b;
    try {
         a = rowA.values[id].props.children;
         b = rowB.values[id].props.children;
    } catch (e) {
        console.log(e);
         a = rowA.values[id];
         b = rowB.values[id];
    }
    

    // Regular expression to match the prefix and numeric suffix
    const regex = /^#?([a-zA-Z]+)(\d+)?$/;

    // Parse the alphabetic and numeric parts
    const matchA = a.match(regex);
    const matchB = b.match(regex);

    if (matchA && matchB) {
        const prefixA = matchA[1].toLowerCase(); // Compare case-insensitively
        const prefixB = matchB[1].toLowerCase();

        // Compare alphabetic part
        if (prefixA !== prefixB) {
            return prefixA > prefixB ? 1 : -1;
        }

        // Compare numeric part, if present
        const numA = matchA[2] ? parseInt(matchA[2], 10) : 0;
        const numB = matchB[2] ? parseInt(matchB[2], 10) : 0;

        return numA - numB;
    }

    // If one of them doesn't match the pattern, keep it at the bottom
    return a.localeCompare(b);
}